import React, {CSSProperties, ReactNode} from "react";
import {Tooltip} from "primereact/tooltip";
import DomHelper from "../helper/DomHelper";
import FunctionHelper from "../helper/FunctionHelper";
import PortalPureComponent from "./PortalPureComponent";

/**
 * The properties for an {@link Icon} component
 */
interface IconProperties {
	icon: string;
	tooltip?: ReactNode,
	position?: 'top' | 'bottom' | 'left' | 'right'
	style?: CSSProperties;
	autoHide?: boolean;
	tooltipStyle?: CSSProperties;
	tooltipClass?: string;
	onClick?: (event: React.MouseEvent) => void;
}

/**
 * This component is an icon element combined with an optional {@link Tooltip} to make this often used combination
 * reusable
 */
export default class Icon extends PortalPureComponent<IconProperties, any> {
	private id: string;

	/**
	 * Constructs an {@link Icon} instance
	 */
	constructor(props: Readonly<IconProperties>) {
		super(props);

		this.id = DomHelper.generateUUID();
	}

	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let classList: Array<string> = ["icon", "icon-tooltip-" + this.id];

		for (let iconClass of this.props.icon.split(" ")) {
			classList.push(iconClass);
		}

		return (
			<>
				<span className={classList.join(" ")} style={this.props.style}
					  onClick={(event) => {
						  // consume events to prevent label clicks
						  event.preventDefault();
						  event.stopPropagation();

						  if (FunctionHelper.exists(this.props.onClick)) {
							  this.props.onClick!(event);
						  }
					  }}/>
				{FunctionHelper.exists(this.props.tooltip) &&
					<Tooltip target={".icon-tooltip-" + this.id} autoHide={this.props.autoHide}
							 style={{maxWidth: "300px", whiteSpace: "normal", ...this.props.tooltipStyle}}
							 appendTo={document.getElementById("root")}
							 position={FunctionHelper.applyValue(this.props.position, "right")}
							 className={this.props.tooltipClass}>
						{this.props.tooltip}
					</Tooltip>
				}
			</>
		);
	}
}